var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1909_2045",
    transform: "matrix(0.0175439 0 0 0.0200501 0 -0.00125313)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1909_2045",
    width: 57,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAyCAYAAADm33NGAAABhElEQVRoge3aQRKCMAwF0F/HtWy19z8brPECuHBQLHZsk/zo1P4dbsIbSknAsCzLgsZz+PYJeKQjW0lHtpJq5DxfMc9XxrnQ6h1rC47j9DgehpOquFe94iuZFhzHiXpFLeup7kkWNAVqU4wchhNivOx+t4bmgDFe+MsV4EMZQECwXFlQFhAQ3pPWUCYQUGw8VlA2EFDurlqoBxAwaOukUC8gYNS71kI9gYBhg14K9QYClb3rp6wnmSLS9iwNEwgAgfGOJ9+WBQCv5dhAgDRP5pbuHRgeRx5AwHi5bpNbuis0xrMLEHB5MxDe/Ob7FpSGfN6Xr0t0DXse3YaC3G8834WaI/PPwbPLPPouphtP6YM+9xxlbURmV7IU6PWGYRsTZG2r5g1VI6W9qCdUhdQ2215QMdJqmvCAipDW4xIbKvoWwhiXmNAqJHvgZUHF30LWWI9LDKhqd2XNg/l5VBbxtxD2wGtZr6p3TdszdqzqUd7x/Fr6fwZaSUe2ko5sJR3ZSv4CeQMd02YxauEO9gAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.fffbc7c04e224f5a1652aa937f1fe1df.svg";
export { ForwardRef as ReactComponent };